<template>
    <RegistrationAndLoginSupportError></RegistrationAndLoginSupportError>
</template>

<script>
    import RegistrationAndLoginSupportError from "../components/RegistrationAndLoginSupportError";

    export default {
        name: "registration-and-login-support-error",
        components: {
            RegistrationAndLoginSupportError,
        }
    };
</script>
